module.exports = __webpack_public_path__ + "img/sort-icon-5.148eb7cb.png";